import { render, staticRenderFns } from "./ClientStats.vue?vue&type=template&id=7f5f4504"
import script from "./ClientStats.vue?vue&type=script&lang=js"
export * from "./ClientStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports